export default __webpack_public_path__ + "static/media/Tutorial-Step-1.1.0985dee5.jpg";